import { v4 as uuidv4 } from 'uuid';

import { useAppDispatch } from '@verantos-dev/app-state-base';

import {
  clearResearchAssistantIsProcessing,
  setResearchAssistantIsProcessing,
} from './researchAssistantSlice';

export const useSetResearchAssistantToProcessing = () => {
  const dispatch = useAppDispatch();

  const setResearchAssistantToProcessingWithAutoTimeout = () => {
    const transactionId = uuidv4();
    dispatch(setResearchAssistantIsProcessing({ transactionId }));

    // setTimeout(() => {
    //   dispatch(clearResearchAssistantIsProcessing({ transactionId }));
    // }, 30000);
  };

  return setResearchAssistantToProcessingWithAutoTimeout;
};
